import 'rxjs/operators';
function isDefined(element) {
  return element !== void 0;
}
async function hashString(input, algo = "SHA-1") {
  const text = new TextEncoder().encode(input);
  return new Uint8Array(await crypto.subtle.digest(algo, text));
}
function copyKeys(data, keys) {
  return Object.fromEntries(keys.map(k => [k, data[k]]).filter(([, v]) => v !== void 0));
}
export { copyKeys, hashString, isDefined };
